import { makeStyles, mergeClasses } from "@griffel/react";
import { HighContrastSelector } from "@fluentui/style-utilities";

// eslint-disable-next-line no-restricted-imports
import {
  commonHighContrastBackgroundHoverFocus,
  commonHighContrastColorDisabled,
  commonHighContrastColorHoverFocus,
  commonHighContrastOutlineToggledOn,
} from "@1js/acui-common/lib/styling/next/commonStyles";
import { customTokens } from "@1js/acui-theme";

import { useRibbonButtonStyles } from "../../RibbonButton/next/useRibbonButtonStyles";
import { RibbonToggleButtonState } from "./RibbonToggleButton.types";

const useStyles = makeStyles({
  checked: {
    backgroundColor: customTokens.legacy_neutralLight,
    color: customTokens.legacy_neutralDark,

    [HighContrastSelector]: {
      ...commonHighContrastBackgroundHoverFocus,
      ...commonHighContrastColorHoverFocus,
      ...commonHighContrastOutlineToggledOn,
    },
  },
  disabled: {
    [HighContrastSelector]: {
      ...commonHighContrastColorDisabled,
      ":focus": {
        ...commonHighContrastColorDisabled,
      },
    },
  },
});

export const useRibbonToggleButtonStyles = (
  state: RibbonToggleButtonState
): RibbonToggleButtonState => {
  const styles = useStyles();

  state.root.className = mergeClasses(
    state.checked && styles.checked,
    (state.disabled || state.disabledFocusable) && styles.disabled,
    state.root.className
  );

  useRibbonButtonStyles(state);

  return state;
};
